import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class BroadcastAdminService extends BaseService<any> {
  constructor() {
    super(`broadcasts`);
  }
  // POST /api/admin/broadcasts/1/send-message
  // Массовая рассылка всем пользователям
  send = (broadcastId: number) => {
    return appAxios.post(`${this.pathWithOrg()}/${broadcastId}/send-message`);
  }
  // POST /api/admin/broadcasts/1/pause
  pause = (broadcastId: number) => {
    return appAxios.post(`${this.pathWithOrg()}/${broadcastId}/pause`);
  }
  // POST /api/admin/broadcasts/1/resume
  resume = (broadcastId: number) => {
    return appAxios.post(`${this.pathWithOrg()}/${broadcastId}/resume`);
  }
  // POST /api/admin/broadcasts/1/stop
  stop = (broadcastId: number) => {
    return appAxios.post(`${this.pathWithOrg()}/${broadcastId}/stop`);
  }
}

export default new BroadcastAdminService();
